const styles = theme => ({
  firstDiv: {
    display: 'inline',
    position: 'absolute',
    marginLeft: 'calc(100% - 70px)',
    [theme.breakpoints.up('sm')]: {
      marginLeft: 'calc(100% - 80px)',
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: 'calc(100% - 80px)',
    },
  },
  menuButton: {
    zIndex: 5000,
    color: 'white',
  },
  menuList: {
    zIndex: 4000,
  },
  menuIcon: {
    color:'rgba(230, 230, 230, 1.0)',
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/ApplicationBar/components/ToolBar/components/MoreInfo/styles.js